


















import { Component, Vue, Inject} from 'vue-property-decorator'
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
@Component({
    name:'yearCount'
})
export default class yearCount extends AbpBase  {
    initData: any = {
        searchData: {
            beginDt: new Date()
        },
        tableData:{
        loading: true,
        title:[
            {
                title: '部门',
                key: 'belongDepName',
                align: 'center',
            },
            {
                title: '主合同最大号',
                key: 'mainContractMaxCode',
                align: 'center',
            },
            {
                title: '主合同金额（万元）',
                key: 'mainContractTotalAmount',
                align: 'center',
            },
            {
                title: '外协合同最大号',
                key: 'externalContractMaxCode',
                align: 'center',
            },
            {
                title: '外协合同金额（万元）',
                key: 'externalContractTotalAmount',
                align: 'center',
            },
            {
                title: '未返回正式合同',
                key: 'unFormalMainContractCount',
                align: 'center',
            },
            {
                title: '未返回正式外协合同',
                key: 'unFormalExternalContractCount',
                align: 'center',
            },
            {
                title: '空白主合同',
                key: 'emptyMainContractCount',
                align: 'center',
            },
        ],
        content:[]
    },
    }
    //表格变颜色
    rowClassName(row:any,index:any){
        if(row.belongDepName == "合计"){
        
            return 'current'
        }  
    }
    mounted(){
        this.initData.searchData.beginDt = new Date(new Date().getFullYear()+'-01-01');
        this.initData.searchData.endDt = new Date();
        this.GetData();
    }
    GetData() {
        Ajax.post('/api/services/app/ContractStatistic/StatisticYearAsync', this.initData.searchData)
            .then( (res: any) => {
                if(res.data.result){
                    this.initData.tableData.content = res.data.result;
                    this.initData.tableData.loading = false;
                }
            } )
    }
    Export() {
        Ajax.post('/api/ContractFile/ExportStatisticYearAsync', this.initData.searchData, {responseType: 'blob'}).then((res:any)=>{
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
            let fileName = '年度合同登记情况统计表' + '.' + 'xlsx';
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
        });
    }
}
